<template>
  <div class="g-head">
    <div class="g-head-content">
      <div class="content-l">
        <img src="@assets/img/icmef.png" @click="$router.push('/home');" />
        <!-- <div class="line"></div>
        <div class="txt">
          <div>
            <h3 :title="'第83届中国国际医疗器械（春季）博览会'">第83届中国国际医疗器械（春季）博览会</h3>
            <span>官方在线</span>
            <i class="icon iconfont icon-renzheng4"></i>
          </div>
          <p>地点：国家会展中心（上海）</p>
          <p>时间：2020/06/03~06/06</p>
        </div>-->
      </div>
      <div class="content-c">
        <div class="content-c-top">
          <span :class="searchType == 0?'active':''" @click="switchSearch(0)">找产品</span>
          <span :class="searchType == 1?'active':''" @click="switchSearch(1)">找展商</span>
        </div>
        <div class="content-c-bottom">
          <input @keyup.enter="search()" v-if="searchType == 0" type="text" v-model="proText" placeholder="请输入要搜索的产品关键字" />
          <input @keyup.enter="search()" v-if="searchType == 1" type="text" v-model="proText" placeholder="请输入要搜索的展商关键字" />
          <span @click="search()">搜索</span>
        </div>
      </div>
      <!-- <div class="content-r">
        <div class="user" v-if="user">
          <Dropdown trigger="hover">
            <div class="user-logo">
              <img :src="user.headImgUrl" v-if="user.headImgUrl" />
              <img src="@assets/img/empty.png" v-else />
            </div>
            <DropdownMenu slot="list" style="width:100px; text-align: center;">
              <DropdownItem @click.native="modelShow=true">我的信息</DropdownItem>
              <DropdownItem @click.native="collectOpen=true">收藏企业</DropdownItem>
              <DropdownItem @click.native="procollectOpen=true">关注产品</DropdownItem>
              <DropdownItem @click.native="linkToEx">展商登录</DropdownItem>
              <DropdownItem @click.native="exit">退出登录</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div v-else style="width:40px;height:1px;"></div>
      </div> -->
    </div>

    <editInfo :show="modelShow" :modelTitle="modelTitle" @close="modelShow = false" @finsh="finsh"></editInfo>
    <myCollect :show="collectOpen" @close="collectOpen=false"></myCollect>
    <proCollect :show="procollectOpen" @close="procollectOpen=false"></proCollect>
  </div>
</template>

<script>
import config from "@assets/config.json";
import editInfo from "../modal/edit-info";
import myCollect from "../modal/my-collect";
import proCollect from "../modal/pro-collect";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "g-head",
  data() {
    return {
      modelShow: false,
      collectOpen:false,
      procollectOpen:false,
      modelTitle: "我的信息",
      searchType: 0, // 0 找产品，1 找展商
      proText: "",
      exText: ""
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      searchContent: "exhibitor/getSearchContent"
    })
  },
  components: {
    editInfo,
    myCollect,
    proCollect
  },
  watch: {
    searchContent(val, oldVal) {
      if (val == "") {
        this.proText = "";
        this.exText = "";
      }
    }
  },
  created() {
    console.log(this.user);
  },
  methods: {
    ...mapActions({
      exit: "loginModule/exit"
    }),
    ...mapMutations({
      setSearchType: "exhibitor/setSearchType",
      setSearchContent: "exhibitor/setSearchContent"
    }),
    search() {
      this.$router.push("/ex-list");
      if (this.searchType == 0) {
        this.setSearchType(0);
        this.setSearchContent(this.proText);
      } else {
        this.setSearchType(1);
        this.setSearchContent(this.proText);
      }
    },
    switchSearch(e) {
      // if (e == 0) {
      //   this.exText = "";
      // } else {
      //   this.proText = "";
      // }
      this.searchType = e;
    },
    linkTo() {
      window.open(
        "https://www.larspring.com/front/exhibitionregister/toExhibitionPage/23d7e4b773614d1780bc6670ade88cf2?sid=f22da08f462d405f8a309ae0e6d26d8c"
      );
    },
    finsh() {},
    linkToEx() {
      window.open(`${config.BackendUrl}/exhibition/login/alogin`);
    }
  }
};
</script>

<style lang="scss" scoped>
.g-head {
  width: 100%;
  height: 108px;
  background: #fff;
  padding-top: 8px;
  &-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    .content-l {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 200px;
        height: auto;
        cursor: pointer;
        margin-top: 30px;
        margin-left: -45px;
      }
    }
    .content-c {
      padding-top: 32px;
      margin-left: 265px;
      &-top {
        width: 100%;
        span {
          display: inline-block;
          width: 64px;
          height: 28px;
          color: #4d4d4d;
          font-size: 14px;
          text-align: center;
          line-height: 28px;
          cursor: pointer;
        }
        .active {
          background-color: #024c8b;
          color: #fff;
        }
      }
      &-bottom {
        display: flex;
        input {
          width: 264px;
          height: 32px;
          border: solid 1px #024c8b;
          outline: none;
          padding: 0 50px 0 10px;
          background-color: #fff;
        }
        ::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #ccc;
          font-size: 12px;
        }
        ::-moz-placeholder {
          /* Firefox 19+ */
          color: #ccc;
          font-size: 12px;
        }
        :-ms-input-placeholder {
          /* IE 10+ */
          color: #ccc;
          font-size: 12px;
        }
        :-moz-placeholder {
          /* Firefox 18- */
          color: #ccc;
          font-size: 12px;
        }
        span {
          display: inline-block;
          width: 64px;
          height: 32px;
          background-color: #024c8b;
          font-size: 14px;
          color: #fff;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .content-r {
      height: 100%;
      padding-top: 60px;
      margin-left: 400px;
      p {
        width: 124px;
        height: 32px;
        background-color: #024c8b;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
      p:first-child {
        margin-bottom: 4px;
      }
    }
  }
}
.user {
  text-align: right;
  &-logo {
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #efefee;
    }
  }
}
</style>